/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsBasemoduleTesterData } from './hosports-basemodule-tester.data';
import { IHosportsBasemoduleTesterProps } from './hosports-basemodule-tester.props.autogenerated';

export interface IHosportsBasemoduleTesterViewProps extends IHosportsBasemoduleTesterProps<IHosportsBasemoduleTesterData> {

}

/**
 *
 * HosportsBasemoduleTester component
 * @extends {React.PureComponent<IHosportsBasemoduleTesterProps<IHosportsBasemoduleTesterData>>}
 */
class HosportsBasemoduleTester extends React.PureComponent<IHosportsBasemoduleTesterProps<IHosportsBasemoduleTesterData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsBasemoduleTester;
